import { html, LitElement } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { dateFormatter } from '@nirvana/shared/time';
import { styles } from '../view/styles';

/**
 * @summary Displays a formatted string with the specified reporting interval
 */
@customElement('gz-reporting-period')
export class GzReportingPeriodWebComponent extends LitElement {
  /**
   * Left margin of reporting interval in milliseconds
   * @type {number}
   */
  @property({
    type: Number,
  })
  public fromTimestamp: number;

  /**
   * Right margin of reporting interval in milliseconds
   * @type {number}
   */
  @property({
    type: Number,
  })
  public toTimestamp: number;

  /**
   * Timezone to display the reporting interval according to https://www.php.net/manual/en/timezones.php
   * @type {string}
   */
  @property({
    type: String,
  })
  public timezone = 'UTC';

  /**
   * Reporting period text before displaying the actual interval
   * @type {string}
   */
  @property({
    type: String,
  })
  public title: string;

  /**
   * Format to display the dates from the interval.
   * Supported values: https://momentjs.com/docs/#/displaying/format/
   * @type {string}
   */
  @property({
    type: String,
  })
  public dateFormat = 'D MMM YYYY HH:mm';

  static get styles() {
    return styles;
  }

  render() {
    const intervalStart = dateFormatter(this.fromTimestamp, this.timezone, this.dateFormat);
    const intervalEnd = dateFormatter(this.toTimestamp, this.timezone, this.dateFormat);

    return html`<div class="reporting-period-wrapper">
      <span class="reporting-period-title">${this.title}</span>
      <span class="reporting-period-interval">${intervalStart} - ${intervalEnd}</span>
    </div>`;
  }
}
